import React from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Space,
  Table,
} from "antd";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import SensorStore from "../store/SensorStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";

class SensorAdd extends React.Component {
  constructor(props) {
    super(props);
    this.sensorStore = new SensorStore();
    this.companyStore = new CompanyStore(this);

    this.state = {
      companyId: "",
      company_value_label: "",
      vehicleList: [],
      loading: false,
      sensorRows: [this.newRow()],
    };
  }

  newRow() {
    return {
      key: Date.now() + Math.random(),
      Id: -1,
      vehicleId: undefined,
      sensorId: "",
      sensorName: "",
      tempCalibrationFactor: "",
      humidityCalibrationFactor: "",
    };
  }

  async componentDidMount() {
    if (this.props.editData?.sensorId) {
      const data = this.props.editData;
      if (data.companyId) {
        await this.loadVehicles(data.companyId);
        const singleData = await this.companyStore.getCompanyDataById(data.companyId);
        this.setState({
          company_value_label: singleData,
          companyId: data.companyId,
          sensorRows: [{
            key: Date.now(),
            Id: data.id || data.Id,
            vehicleId:               data.vehicleId,
            sensorId:                data.sensorId,
            sensorName:              data.sensorName,
            tempCalibrationFactor:   data.tempCalibrationFactor,
            humidityCalibrationFactor: data.humidityCalibrationFactor,
          }],
        });
      }
    }
  }

  loadVehicles = async (companyId) => {
    const response = await this.sensorStore.getAssetList({ companyId });
    this.setState({ vehicleList: response ?? [] });
  };

  handleCompanyChange = async (comp) => {
    if (comp) {
      this.setState({
        companyId: comp.value,
        company_value_label: comp,
        sensorRows: [this.newRow()],
        vehicleList: [],
      });
      await this.loadVehicles(comp.value);
    }
  };

  addRow = () => {
    this.setState((prev) => ({
      sensorRows: [...prev.sensorRows, this.newRow()],
    }));
  };

  deleteRow = (key) => {
    this.setState((prev) => ({
      sensorRows: prev.sensorRows.filter((r) => r.key !== key),
    }));
  };

  updateRow = (key, field, value) => {
    this.setState((prev) => ({
      sensorRows: prev.sensorRows.map((r) =>
        r.key === key ? { ...r, [field]: value } : r
      ),
    }));
  };

  handleSubmit = async () => {
    if (!this.state.companyId) return;

    const validRows = this.state.sensorRows.filter(
      (r) => r.vehicleId && r.sensorId && r.sensorName
    );
    if (!validRows.length) return;

    this.setState({ loading: true });
    const payload = {
      companyId: this.state.companyId,
      GridDetails: validRows.map((r) => ({
        Id: r.Id || -1,
        sid: r.sid || "",
        vehicleId: r.vehicleId,
        sensorId: r.sensorId,
        sensorName: r.sensorName,
        calibrationFactor: r.tempCalibrationFactor || "",
        humidityCalFactor: r.humidityCalibrationFactor || "",
      })),
    };

    const response = await this.sensorStore.updateSensor(payload);
    this.setState({ 
      loading: false,
      sensorRows: [this.newRow()],
      companyId: "",
      company_value_label: "",
      vehicleList: [],
    });
    this.props.response(response);
  };

  render() {
    const { sensorRows, vehicleList, companyId } = this.state;

    const columns = [
      {
        title: "Sr No",
        width: 65,
        align: "center",
        render: (_, __, index) => index + 1,
      },
      {
        title: <span>{this.context.translate("_VEHICLE_NO_")}</span>,
        dataIndex: "vehicleId",
        width: 180,
        render: (val, record) => (
         <Select
                showSearch
                optionFilterProp="label"
                placeholder={this.context.translate("_VEHICLE_NO_")}
                value={val || undefined}
                style={{ width: "100%" }}
                disabled={!companyId}
                onChange={(v) => this.updateRow(record.key, "vehicleId", v)}
                options={vehicleList.map((v) => ({
                    value: v.vehicleId ?? v.assetId,
                    label: v.vehicleNo ?? v.assetName,
                }))}
                />
        ),
      },
      {
        title: <span>{this.context.translate("_SENSOR_ID_")}</span>,
        dataIndex: "sensorId",
        width: 130,
        render: (val, record) => (
          <Input
            value={val}
            placeholder={this.context.translate("_SENSOR_ID_")}
            onChange={(e) => this.updateRow(record.key, "sensorId", e.target.value)}
          />
        ),
      },
      {
        title: <span>{this.context.translate("_SENSOR_NAME_")} </span>,
        dataIndex: "sensorName",
        width: 150,
        render: (val, record) => (
          <Input
            value={val}
            placeholder={this.context.translate("_SENSOR_NAME_")}
            onChange={(e) => this.updateRow(record.key, "sensorName", e.target.value)}
          />
        ),
      },
      {
        title: this.context.translate("_TEMP_CALIBRATION_FACTOR_"),
        dataIndex: "tempCalibrationFactor",
        width: 180,
        render: (val, record) => (
          <Input
            type="number"
            value={val}
            placeholder="0"
            onChange={(e) => this.updateRow(record.key, "tempCalibrationFactor", e.target.value)}
          />
        ),
      },
      {
        title: this.context.translate("_HUMIDITY_CALIBRATION_FACTOR_"),
        dataIndex: "humidityCalibrationFactor",
        width: 200,
        render: (val, record) => (
          <Input
            type="number"
            value={val}
            placeholder="0"
            onChange={(e) => this.updateRow(record.key, "humidityCalibrationFactor", e.target.value)}
          />
        ),
      },
      {
        title: this.context.translate("_ACTION_"),
        width: 65,
        align: "center",
        render: (_, record) => (
          <DeleteOutlined
            style={{
              color:  sensorRows.length === 1 ? "#ccc"    : "#ff4d4f",
              cursor: sensorRows.length === 1 ? "not-allowed" : "pointer",
              fontSize: "16px",
            }}
            onClick={() => sensorRows.length > 1 && this.deleteRow(record.key)}
          />
        ),
      },
    ];

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%", position: "relative" }}>

        {/* ── Scrollable Body ─────────────────────────────────── */}
        <div style={{ flex: 1, overflowY: "auto", padding: "16px 24px", paddingBottom: "80px" }}>

          {/* Company dropdown */}
          <Form layout="vertical">
            <Form.Item
              label={this.context.translate("_ACCOUNT_")}
              required
            >
              <CompanyAutocomplete
                value={this.state.company_value_label || null}
                onChange={this.handleCompanyChange}
                style={{ width: "50%" }}
                fromAccountList={1}
              />
            </Form.Item>
          </Form>

          {/* Add Sensor Row button */}
          <div style={{ marginBottom: "12px",marginTop:"10px" }}>
            <Button
              className="addsensorButtonClass"
              icon={<PlusOutlined />}
              onClick={this.addRow}
              disabled={!companyId}
            >
              {this.context.translate("_ADD_SENSOR_")}
            </Button>
          </div>

          {/* Dynamic rows table */}
          <Table
            dataSource={sensorRows}
            columns={columns}
            pagination={false}
            rowKey="key"
            scroll={{ x: "max-content" }}
            bordered
            size="middle"
          />
        </div>

        {/* ── Fixed Bottom Buttons ────────────────────────────── */}
        <div
          style={{
            position:   "absolute",
            bottom:     0,
            left:       0,
            right:      0,
            padding:    "16px 24px",
            background: "#fff",
            borderTop:  "1px solid #f0f0f0",
            display:    "flex",
            justifyContent: "flex-end",
          }}
        >
          <Space>
            <Button
              className="cancelButtonClass"
              onClick={() => this.props.closeModal()}
            >
              {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
            </Button>

            <Button
              type="primary"
              className="addButtonClass"
              loading={this.state.loading}
              onClick={this.handleSubmit}
            >
              {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
            </Button>
          </Space>
        </div>

      </div>
    );
  }
}

SensorAdd.contextType = StoreContext;
export default observer(withRouter(SensorAdd));